var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabSettings = function SvgTabSettings(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4995",
    width: 32,
    height: 32,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5015",
    d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0m0 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5528",
    d: "M16 7a9 9 0 1 0 0 18 9 9 0 0 0 0-18m0 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect5533",
    d: "M14.5 5v5.094c.484-.054.993-.094 1.5-.094s1.016.04 1.5.094V5zm0 16.906V27h3v-5.094c-.484.054-.993.094-1.5.094s-1.016-.04-1.5-.094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5589",
    d: "m9.283 24.839 3.601-3.602a14 14 0 0 1-1.127-.994c-.358-.359-.69-.747-.994-1.127L7.16 22.718zm11.955-11.955 3.601-3.602-2.121-2.121-3.602 3.602c.38.304.769.635 1.127.994.359.359.69.747.995 1.127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5591",
    d: "M5 17.5h5.094C10.04 17.016 10 16.507 10 16s.04-1.016.094-1.5H5zm16.906 0H27v-3h-5.094c.054.484.094.993.094 1.5s-.04 1.016-.094 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5593",
    d: "m7.161 9.283 3.602 3.601c.304-.38.636-.768.994-1.127.359-.358.747-.69 1.127-.994L9.283 7.16zm11.955 11.955 3.602 3.601 2.121-2.121-3.601-3.602c-.305.38-.636.769-.995 1.127-.358.359-.746.69-1.127.995"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabSettings);
export default ForwardRef;